import { render } from "./ManageAboutPage.vue?vue&type=template&id=2579137e"
import script from "./ManageAboutPage.vue?vue&type=script&lang=ts"
export * from "./ManageAboutPage.vue?vue&type=script&lang=ts"

import "./ManageAboutPage.vue?vue&type=style&index=0&id=2579137e&lang=scss"
script.render = render

export default script